export default "__VITE_PUBLIC_ASSET__439174de__"